// DATA
export const DATA_FETCH_SUBMITTED = 'DATA_FETCH_SUBMITTED';
export const DATA_FETCH_SUCCESS = 'DATA_FETCH_SUCCESS';
export const DATA_DELETE_SUCCESS = 'DATA_DELETE_SUCCESS';
export const DATA_FETCH_ERROR = 'DATA_FETCH_ERROR';
export const DATA_UPDATE_SUCCESS = 'DATA_UPDATE_SUCCESS';

// region LOGIN / LOGOUT
export const IDENTITY_LOGIN_SUCCESS = 'IDENTITY_LOGIN_SUCCESS';
export const IDENTITY_LOGIN_FAILED = 'IDENTITY_LOGIN_FAILED';
export const IDENTITY_LOGOUT_SUCCESS = 'IDENTITY_LOGOUT_SUCCESS';
// endregion

// region CONTRACT
export const CONTRACT_IMAGES = 'CONTRACT_IMAGES';
// endregion
